import APIClient from '@/shared/http/clients/api'

const resourceName = 'coordenadorregional'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAll = (companyID, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/empresa/${companyID}`, data, config)
const GetAllPaging = (companyID, limit, index, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/empresa/${companyID}?limit=${limit}&index=${index}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/${id}`, config)
const GetByRegional = (id, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/regional/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APIBusinessCommon}/${resourceName}/${id}`, config)

const CoordinatorRepository = {
  GetAll,
  GetAllPaging,
  GetById,
  GetByRegional,
  Create,
  Update,
  Delete
}

export default CoordinatorRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configuration/coordinator.js